import { SubSegment } from "src/components/routes/SetupPayments/common/consts/subsegment";
import { usePrimaryCreditor } from "src/libraries/creditor/hooks";
import { useOptimizelyVariation } from "src/technical-integrations/optimizely/useOptimizelyVariation";
import { OptimizelyFlag } from "src/technical-integrations/optimizely/constants";
import { BASE_TEMPLATES } from "src/components/routes/SetupPayments/preferred-payments/consts";

export interface UseEasyPaymentDecision {
  enabled: boolean;
  isVariationOn: boolean;
  isAllowed: boolean;
  subSegment: SubSegment | undefined;
}

export const useEasyPaymentDecision = (): UseEasyPaymentDecision => {
  const { isVariationOn } = useOptimizelyVariation({
    flag: OptimizelyFlag.TURBO_GROWTH_EASY_PAYMENT_DECISION,
  });
  const creditor = usePrimaryCreditor();
  const subSegment = creditor?.sub_segment as SubSegment | undefined;
  const allowedSubSegments = Object.keys(BASE_TEMPLATES) as SubSegment[];
  const isAllowed = !!subSegment && allowedSubSegments.includes(subSegment);

  return {
    enabled: isVariationOn && isAllowed,
    isVariationOn,
    isAllowed,
    subSegment,
  };
};
